/**
 * E2E Mock Providers
 * 
 * This file is conditionally loaded when E2E_TEST_MODE is enabled.
 * 
 * NOTE: Services are now function-based, not class-based, so we can't use Angular DI to replace them.
 * E2E tests now use HTTP route interception via Playwright's page.route() API.
 * See playwright/e2e-tests/mocks/http-routes/ for the new mock implementation.
 * 
 * This file returns an empty array since HTTP route mocks are set up automatically
 * in the test-setup.ts fixture.
 */

import { Provider } from '@angular/core';

/**
 * Returns Angular providers that replace all real API services with mocks
 * This function is called from app.module.ts when E2E_TEST_MODE is enabled
 * 
 * NOTE: Since services are now function-based (not class-based), we can't use Angular DI
 * to replace them. E2E tests now use HTTP route interception via Playwright's page.route() API.
 * HTTP route mocks are automatically set up in playwright/e2e-tests/helpers/test-setup.ts
 */
export function getE2EMockProviders(): Provider[] {
  // Services are function-based, not class-based, so we can't use Angular DI to mock them
  // E2E tests use HTTP route interception instead (see playwright/e2e-tests/mocks/http-routes/)
  return [];
}
